
function IssueEventsCtrl(TranslationService, ToastService, HelpdeskService) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();

    

}

IssueEventsCtrl.$inject = ['TranslationService', 'ToastService', 'HelpdeskService'];

seedWebApp.component('issueEvents', {
    controller: IssueEventsCtrl,
    bindings: {
        loading: '<',
        issue: '<',
        activities: '<',
    },
    templateUrl: '/SPA/helpdesk/issue-events.html' + seedWebApp.buildVersion
});